import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShoppingCart, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';

const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const FitnessEnergy = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [isAdded, setIsAdded] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const product = {
    id: 'energy',
    title: 'חטיפי אנרגיה',
    description: 'חטיפי אנרגיה טעימים ובריאים, מושלמים לאכילה לפני, במהלך או אחרי האימון. עשירים בחלבון ופחמימות איכותיות.',
    price: 149,
    image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/k794rgqs_cf2c16_b4aa4432794c4015b8dfa3434bc6de13~mv2.avif'
  };

  const handleButtonClick = () => {
    if (isAdded) {
      navigate('/cart');
    } else {
      addToCart({
        id: product.id,
        name: product.title,
        description: product.description,
        price: product.price,
        image: product.image,
        quantity: 1
      });
      
      playCartSound();
      setIsAdded(true);
      setShowPopup(true);
      
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  return (
    <div className="container py-8" data-testid="fitness-energy-page">
      {/* Popup */}
      {showPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-bounce">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}

      {/* Back Button */}
      <button
        onClick={() => navigate('/fitness')}
        className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors mb-8"
        data-testid="back-button"
      >
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start max-w-5xl mx-auto">
        {/* Image */}
        <div className="rounded-2xl overflow-hidden shadow-lg">
          <img
            src={product.image}
            alt={product.title}
            className="w-full h-auto"
            data-testid="product-image"
          />
        </div>

        {/* Content */}
        <div className="space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="product-title">
            {product.title}
          </h1>

          <div className="prose prose-lg text-stone-600" data-testid="product-description">
            <p>{product.description}</p>
            <h3 className="text-[#2C3E2D] font-bold mt-6">יתרונות המוצר:</h3>
            <ul className="space-y-2">
              <li>אנרגיה מהירה וממושכת</li>
              <li>עשיר בחלבון ובסיבים תזונתיים</li>
              <li>ללא חומרים משמרים מלאכותיים</li>
              <li>טעמים מגוונים</li>
              <li>נוח לנשיאה לכל מקום</li>
            </ul>
          </div>

          {/* Price */}
          <div className="text-3xl font-bold text-[#D97706]" style={{ fontFamily: 'Heebo, sans-serif' }}>
            {product.price} ש"ח
          </div>

          {/* Button */}
          <button
            onClick={handleButtonClick}
            className={`w-full md:w-auto flex items-center justify-center gap-3 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 ${
              isAdded
                ? 'bg-green-500 text-white hover:bg-green-600'
                : 'bg-[#D97706] text-white hover:bg-[#B45309]'
            } hover:shadow-lg hover:-translate-y-0.5`}
            style={{ fontFamily: 'Heebo, sans-serif' }}
            data-testid="add-to-cart-button"
          >
            <ShoppingCart className="w-6 h-6" />
            {isAdded ? 'מעבר לרכישה' : 'הוסף לסל'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FitnessEnergy;
